import React from 'react';
import { PiFan } from 'react-icons/pi';
import { FiAlertCircle, FiClock } from 'react-icons/fi';

const ExaustorStatusCard = ({ exaustorLabel, finais = [], status, remainingTime, hasError, isLoading, isStale }) => {
  // Rotulo do card: "Final N" quando o exaustor atende um unico final,
  // ou "Finais A e B" quando atende mais de um (dutos convergentes).
  const finaisTexto = finais.length > 1
    ? `Finais ${finais.slice(0, -1).join(', ')} e ${finais[finais.length - 1]}`
    : `Final ${finais[0]}`;

  // Helper para formatar tempo restante
  // < 1m: mostrar segundos | 1m-1h: mostrar minutos | ≥ 1h: mostrar horas e minutos
  const formatRemainingTime = (seconds) => {
    if (seconds < 60) {
      // Menos de 1 minuto: mostrar apenas segundos
      return `${seconds}s`;
    }
    const hours = Math.floor(seconds / 3600);
    if (hours === 0) {
      // Entre 1m e 1h: mostrar apenas minutos
      const minutes = Math.floor(seconds / 60);
      return `${minutes}m`;
    }
    // 1h ou mais: mostrar horas e minutos
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  };

  // Modulo ocupado/nao consultado sem leitura anterior: o backend manda 4,
  // mas nada falhou — so nao houve leitura desta vez
  const semLeitura = isStale && !hasError && status !== 0 && status !== 1;
  const erro = hasError || (status === 4 && !semLeitura);
  const ligado = !erro && status === 1;
  const conhecido = !erro && (status === 0 || status === 1);
  // Sem status ainda (null/undefined) conta como carregando
  const carregando = isLoading || (!erro && !conhecido && !semLeitura);

  // O fundo e o fan seguem o ultimo status conhecido mesmo durante a
  // consulta: so o texto de status vira skeleton, sem piscar o card
  let quadrantClass = 'exaustor-quadrant';
  if (erro && !isLoading) quadrantClass += ' indefinido';
  else if (ligado) quadrantClass += ' on';

  let statusConteudo;
  if (carregando) {
    statusConteudo = <span className="exaustor-card__skeleton" role="img" aria-label="Carregando status" />;
  } else if (semLeitura) {
    statusConteudo = (
      <p className="status-sem-leitura" title="Este exaustor não foi consultado agora. Atualize para tentar de novo.">
        <FiClock aria-hidden="true" />
        Sem leitura
      </p>
    );
  } else if (erro) {
    statusConteudo = (
      <p className="status-erro">
        <FiAlertCircle aria-hidden="true" />
        Erro ao obter status
      </p>
    );
  } else {
    statusConteudo = <p className={ligado ? 'status-ligado' : 'status-desligado'}>{ligado ? 'Ligado' : 'Desligado'}</p>;
  }

  // Modulo ocupado/nao consultado nesta leitura: o card mantem o ultimo
  // status conhecido e avisa que ele pode estar desatualizado
  const mostrarUltimaLeitura = isStale && conhecido && !isLoading;
  const mostrarTempo = ligado && !isLoading && !mostrarUltimaLeitura && remainingTime != null;

  return (
    <div className={quadrantClass}>
      <div className="exaustor-card__icon">
        <span className="fan-icon-badge">
          <PiFan className={`fan-icon ${ligado ? 'spinning' : ''}`} />
        </span>
      </div>
      <div className="exaustor-info">
        <h3>{`Exaustor ${exaustorLabel} — ${finaisTexto}`}</h3>
        <div className="exaustor-card__status">
          {statusConteudo}
          {mostrarUltimaLeitura && (
            <span
              className="exaustor-card__stale-tag"
              title="Sem leitura nesta consulta. Exibindo o último status conhecido."
            >
              <FiClock aria-hidden="true" />
              Última leitura
            </span>
          )}
        </div>
      </div>
      {mostrarTempo && (
        <div className="remaining-time">
          <div className="remaining-time-label">Desliga em</div>
          <div className="remaining-time-value">{formatRemainingTime(remainingTime)}</div>
        </div>
      )}
    </div>
  );
};

export default ExaustorStatusCard;
